import { render, staticRenderFns } from "./edit-limit.vue?vue&type=template&id=d09b6968&scoped=true&"
import script from "./edit-limit.vue?vue&type=script&lang=js&"
export * from "./edit-limit.vue?vue&type=script&lang=js&"
import style0 from "./edit-limit.vue?vue&type=style&index=0&id=d09b6968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09b6968",
  null
  
)

export default component.exports